<template>
<div id="custom-browsing">
    <div id="browsetitles">
        <slot></slot>
    </div>
    <div id="list">
        <div class="list-container">
            <ul class="title-ul">
                <li class="title-li" v-for="value in list" @click="redirectTo(value.id)">
                    <a class="title-a" :class="[currentElementId === value.id ? 'active' : '']">
                        {{ value.title }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'BrowseTitles',
    data: () => {
        return {
            list: [],
            currentElementId: ''
        }
    },
    mounted() {
        var inputs = document.getElementById("browsetitles").children;
        for (var i = 0; i < inputs.length; i++) {
            const title = inputs[i].innerText
            if (inputs[i].id && inputs[i].tagName === 'H3') {
                this.list.push({ title: title.replace('#', '').trim(), id: inputs[i].id})
            }
        }
    },
    methods: {
        redirectTo(elementId) {
            this.currentElementId = elementId
            var element = document.getElementById(elementId);
            var headerOffset = 180;
            var elementPosition = element.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            //element.scrollIntoView({ block: 'start',  behavior: 'smooth' });
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });   
        }
    }
}
</script>
<style>
#custom-browsing {
    display: flex;
    h3, h1 {
        margin-top: -4.5rem;
        padding-top: 6rem;
        margin-bottom: 0;
    }
    #list {
        .list-container {
            width: 182px;
            max-width: 182px !important;
            border-left: 1px solid #9e9e9e;
            margin-left: 24px;
            position: -webkit-sticky;
            position: sticky;
            top: 150px;
            .title-ul {
                list-style-type: none;
                padding-left: 24px !important;
                padding-right: 8px !important;
                .title-li {
                    margin: 8px 0;
                    cursor: pointer;
                    .title-a {
                        font-size: 16px !important;
                        font-weight: 600;
                        letter-spacing: 0px;
                        color: #4C9592 !important;
                        text-decoration: none !important;
                        cursor: pointer;
                        font-family: var(--font-acumin-pro-light) !important;
                        line-height: 18px;
                    }
                    .title-a.active {
                        color: #0A3C45 !important;
                        font-family: var(--font-acumin-pro-semibold) !important;
                    }
                }
                .title-li:hover {
                    .title-a {
                        color: #0A3C45 !important;
                        font-family: var(--font-acumin-pro-semibold) !important;
                    }
                }
            }
        }
    }
}
</style>
